export type TCalcSipRes = {
  investedAmount: number;
  totalWealth: number;
  wealthGained: number;
  sip_wealth_gained: number;
};

export const calculateSipInvestment = (
  expectedReturnRate: number,
  sipPeriod: number,
  monthlySipAmount: number
): TCalcSipRes => {
  const ci = expectedReturnRate / 100 / 12;
  const numberofmonths = sipPeriod * 12;
  const wealthGained =
    monthlySipAmount *
      (Math.pow(1 + ci, numberofmonths) - 1) *
      ((1 + ci) / ci) -
    monthlySipAmount * sipPeriod * 12;
  const investedAmount = monthlySipAmount * sipPeriod * 12;
  return {
    sip_wealth_gained: wealthGained,
    investedAmount: investedAmount,
    totalWealth: wealthGained + investedAmount,
    wealthGained: wealthGained,
  };
};

export const calculateLumpsumInvestment = (
  totalInvestment: number,
  returns: number,
  investmentPeriod: number
): TCalcSipRes => {
  const age_difference = 60 - totalInvestment;
  const investedAmount = age_difference + 1;
  const topercent = 1 + returns / 100;
  const topower = Math.pow(topercent, investmentPeriod);
  const totalWealth = totalInvestment * topower;
  return {
    investedAmount: totalInvestment,
    totalWealth: totalWealth,
    wealthGained: totalWealth - totalInvestment,
    sip_wealth_gained: investedAmount,
  };
};

interface ISIP_FORMULA {
  investmentFrequency: 'sip' | 'lumpsum';
  expectedReturnRate?: number;
  sipPeriod?: number;
  monthlySipAmount?: number;
  totalInvestment?: number;
  returns?: number;
  investmentPeriod?: number;
}

export const SIP_FORMULA = ({
  investmentFrequency = 'sip',
  expectedReturnRate,
  sipPeriod,
  monthlySipAmount,
  totalInvestment,
  returns,
  investmentPeriod,
}: ISIP_FORMULA): TCalcSipRes => {
  if (investmentFrequency === 'sip') {
    if (
      expectedReturnRate === undefined ||
      sipPeriod === undefined ||
      monthlySipAmount === undefined
    ) {
      throw new Error(
        'Invalid SIP parameters. Expected return rate, SIP period, and monthly SIP amount are required.'
      );
    }

    return calculateSipInvestment(
      expectedReturnRate,
      sipPeriod,
      monthlySipAmount
    );
  }

  if (investmentFrequency === 'lumpsum') {
    if (
      totalInvestment === undefined ||
      returns === undefined ||
      investmentPeriod === undefined
    ) {
      throw new Error(
        'Invalid lump sum parameters. Total investment, returns, and investment period are required.'
      );
    }

    return calculateLumpsumInvestment(
      totalInvestment,
      returns,
      investmentPeriod
    );
  }

  throw new Error(
    'Invalid investment type. Please specify "sip" or "lumpsum".'
  );
};
